export const valueFormatters = {
  data() {
    return {
      month: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sept','Oct','Nov','Dec']
    }
  },
  methods: {
    truncateString: function(str, num) {
      if (str?.length > num) {
        let subStr = str.substring(0, num);
        return subStr + "...";
      } else {
        return str;
      }
    },
    stripHTML: function(str) {
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    getDate: function(date) {
      return (new Date(parseInt(date))).toDateString();
    },
    getDay: function(date) {
      return (new Date(parseInt(date))).getDate().toString().padStart(2, '0');
    },
    getMonth: function(date) {
      return this.month[(new Date(parseInt(date))).getMonth()];
    },
    getYear: function(date) {
      return (new Date(parseInt(date))).getFullYear();
    },
  },
};
